import { useEffect, useState } from "react";
import MyTable from "../common/mytable";
import addicon from '../images/additem.png';
import img1 from '../images/accounticon.png';
import axios from "axios";
import loadIcon from '../images/loader2.webp';
const AccountHeads=()=>
{   
    const [show,setShow]=useState(false);
    const [progress,setProgress]=useState(false);
    const [msg,setMsg]=useState("");
    const [acountHeads,setAcountHeads]=useState([]);

    const [formData,setFormData]=useState({id:"",headname:""});
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [
        { name: "ID", key: "id", sortable: true },
        { name: "Account Heads", key: "headname", sortable: true },        
    ];
    function addFacility(event)
    {
        setFormData({id:"",headname:""});
        setShow(true);
    }
    async function saveData(event)
    {
        setMsg("");
        if(formData.headname.trim()=="") return;
        let obj=acountHeads.find(e=>e.headname.trim().toUpperCase()==formData.headname.trim().toUpperCase());
        if(obj)
        {
            setMsg("Account Head Already Exists!!!");
            return;
        }
        if(window.confirm('Are you sure?'))
        {
            
            setProgress(true);
            let url="/api/AccountHeads/SaveAccountHead/"+formData.headname;                        
            let datajson=JSON.stringify(formData);           
                await apiClient.post(url,datajson).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadAccountHeads();
                        alert("Data Saved Successfully");
                        setFormData({id:"",headname:""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });  
            setProgress(false); 
        }
    }
    async function loadAccountHeads()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/AccountHeads/GetAllHeads").then(res=>
        {
            if(res.status==200)
            {
                setAcountHeads(res.data.data);
            }
        });
        setProgress(false);
    }
    function formValueChanged(event)
    {
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});
        if(event.target.id=="headname") setFormData({...formData,headname:event.target.value});        
    }
    async function deleteHead(id)
    {
        let obj=acountHeads.find(e=>e.id==id);
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/AccountHeads/Delete/"+obj.headname).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadAccountHeads();
                }
            });
        }
    }        
    function editHead(id)
    {

    }
    useEffect(()=>{
        loadAccountHeads();
    },[]);
    return(
        <div>
            <div className="p-2 text-end">
                <div className="text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addFacility} /></div>
            </div>
            <MyTable tbldata={acountHeads} heading="Account Heads" columns={columns} isView={false} isEdit={false} isDelete={true} editFunction={editHead}  deleteFunction={deleteHead} />
                {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{height:'70px',marginRight:'10px'}} />Account Head</div>
                                    <input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/>
                                    <input type="text" id="headname" onChange={formValueChanged} value={formData.headname} className="form-control mt-2" placeholder="Head Name" />                                    
                                    <input type="button" className="btn btn-danger mt-2" onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default AccountHeads;